import { fromTimeString } from '@/libs/utilities/gql-scalar'
import type { SortCalendarSummaryFunctionCalendarSummaryFragment } from './sort.generated'

export type SortOption = 'createdAtAsc' | 'createdAtDesc'

export const sortCalendarSummary = <
  T extends SortCalendarSummaryFunctionCalendarSummaryFragment,
>(
  sortOption: SortOption,
  target: T[]
): T[] => {
  const result = [...target]

  // eslint-disable-next-line fp/no-mutating-methods
  return result.sort((a, b) => {
    const dateA = fromTimeString(a.createdAt).getTime()
    const dateB = fromTimeString(b.createdAt).getTime()

    switch (sortOption) {
      case 'createdAtAsc':
        return dateA - dateB
      case 'createdAtDesc':
        return dateB - dateA
      default:
        throw new Error(`Unknown sort option: ${sortOption}`)
    }
  })
}
